import aws from '../assets/png/aws.JPG';
import nse1 from '../assets/png/nse1.JPG';
import nse2 from '../assets/png/nse2.JPG';
import sql from '../assets/png/sql.JPG';
import python from '../assets/png/python.JPG';
import placeholder from '../assets/png/placeholder.png';
import societyScreenshot from '../assets/png/Screenshot 2026-04-21 at 15.14.29.png';

export const profile = {
  name: 'Arijit Das',
  role: 'Enterprise Software Engineer',
  eyebrow: 'Software Engineer',
  specialization: 'Backend / Cloud / AI',
  company: 'Deloitte USI',
  location: 'Kolkata, India',
  availability: 'Open to enterprise backend, cloud, and AI application roles',
  email: 'das10arijit@gmail.com',
  phone: '+91 8910666069',
  image: 'https://avatars.githubusercontent.com/u/88399881?s=400&u=d06264de838a2268ee06686ca97e8967429ddc14&v=4',
  resume: 'https://drive.google.com/file/d/1gkzbpZ3vYMO8U0gwqmqpBHqMgT_YvoN-/view?usp=sharing',
  github: 'https://github.com/arijit2002',
  linkedIn: 'https://www.linkedin.com/in/arijitdas10/',
  intro:
    'Software engineer at Deloitte working across backend systems, cloud, React, and Python.',
};

export const metrics = [
  { value: '2+', label: 'Years experience', detail: 'Enterprise delivery and production systems' },
  { value: 'Deloitte', label: 'Current Role', detail: 'Associate Analyst at Deloitte USI' },
  { value: 'AWS', label: 'Certified', detail: 'Cloud Practitioner credential' },
  { value: '14+', label: 'Projects shipped', detail: 'Backend, cloud, full stack, and data apps' },
];

export const about = {
  intro:
    'I build backend-heavy software with clean APIs, reliable data flows, cloud services, and practical user interfaces.',
  strengths: [
    'Enterprise work with Deloitte, Qualtrics, and Medallia',
    'Backend systems with Node.js, Python, auth, data modeling, and APIs',
    'Cloud development with AWS, Docker, and deployment-focused architecture',
    'Full stack work with React and production-ready backend services',
  ],
  focus: [
    'ThrottleSync, a private startup product currently in active development',
    'AI-backed app ideas with useful workflows',
    'Cloud infrastructure and serverless services',
    'Scalable APIs and integration layers',
    'Maintainable systems for real teams',
  ],
  philosophy:
    'I like simple interfaces, clear data contracts, and systems that are easy to operate after launch.',
};

export const serviceOfferings = [
  {
    title: 'Web Development',
    icon: 'Web',
    description: 'Responsive web applications with practical interfaces, clean routing, and maintainable React structure.',
    technologies: ['React', 'JavaScript', 'Node.js', 'Express.js'],
  },
  {
    title: 'Mobile App Development',
    icon: 'Mobile',
    description: 'Cross-platform product flows for mobile use cases that need accounts, data, maps, or APIs.',
    technologies: ['React Native', 'JavaScript', 'Firebase', 'REST APIs'],
  },
  {
    title: 'Backend & API Development',
    icon: 'Server',
    description: 'Secure APIs, authentication, database models, background logic, and integration layers.',
    technologies: ['Node.js', 'Express.js', 'Python', 'Flask', 'Java', 'Spring Boot'],
  },
  {
    title: 'E-commerce Development',
    icon: 'Commerce',
    description: 'Commerce systems with product data, order flows, payment integration, and admin workflows.',
    technologies: ['MERN Stack', 'Payment Integrations', 'MongoDB', 'Databases'],
  },
  {
    title: 'Cloud & Deployment',
    icon: 'Cloud',
    description: 'Deployment paths, cloud services, containers, and release setups that teams can operate.',
    technologies: ['AWS', 'Firebase', 'Render', 'Netlify', 'Docker'],
  },
  {
    title: 'Maintenance & Optimization',
    icon: 'Maintain',
    description: 'Focused fixes, performance work, refactors, and feature additions for existing products.',
    technologies: ['Debugging', 'Performance', 'Feature Development', 'Refactoring'],
  },
];

export const developmentProcess = [
  {
    step: '01',
    title: 'Understand',
    description: 'Understand the business, requirements and goals.',
  },
  {
    step: '02',
    title: 'Plan',
    description: 'Define features, architecture, technology and milestones.',
  },
  {
    step: '03',
    title: 'Build',
    description: 'Develop the application using modern and scalable technologies.',
  },
  {
    step: '04',
    title: 'Test & Deploy',
    description: 'Test the application and deploy it to production.',
  },
  {
    step: '05',
    title: 'Support',
    description: 'Provide improvements, maintenance and future development.',
  },
];

export const whyWorkWithMe = [
  'Full-stack development',
  'End-to-end project ownership',
  'Modern technology stack',
  'Responsive design',
  'Scalable architecture',
  'API integrations',
  'Payment integrations',
  'Cloud deployment',
  'Clear communication',
  'Post-launch support',
];

export const experience = [
  {
    company: 'Deloitte USI',
    role: 'Associate Analyst',
    duration: 'Feb 2024 - Present',
    logo: 'D',
    impact:
      'Working on enterprise customer-experience platforms and implementation workflows where reliability, stakeholder clarity, and platform constraints matter.',
    technologies: ['Qualtrics', 'Medallia', 'APIs', 'Enterprise Platforms', 'Data Workflows'],
    achievements: [
      'Built practical experience with enterprise delivery standards and stakeholder-driven software work.',
      'Worked around platform integrations, configuration, and customer-experience technology ecosystems.',
      'Strengthened production-minded habits around reliability, traceability, and business impact.',
    ],
  },
  {
    company: 'Google Developer Students Club IEM',
    role: 'WebDev Lead',
    duration: 'Aug 2022 - Jul 2023',
    logo: 'G',
    impact:
      'Led web development initiatives, helped peers ship projects, and practiced translating technical ideas into usable products.',
    technologies: ['React', 'Node.js', 'JavaScript', 'Mentoring', 'Community'],
    achievements: [
      'Guided students through web development workflows and project execution.',
      'Built leadership experience across collaboration, reviews, and technical planning.',
    ],
  },
  {
    company: 'IEM Labs',
    role: 'Backend Developer',
    duration: 'Feb 2023 - Mar 2023',
    logo: 'I',
    impact:
      'Worked on backend development tasks with a focus on APIs, server-side logic, and practical application delivery.',
    technologies: ['Backend', 'APIs', 'Node.js', 'Databases'],
    achievements: [
      'Improved hands-on backend implementation skills in a team environment.',
      'Contributed to application logic and server-side development workflows.',
    ],
  },
];

export const featuredProjects = [
  {
    id: 'throttlesync',
    name: 'ThrottleSync',
    category: 'Featured Product',
    image: '',
    problem:
      'Riders need a focused way to track rides, compare performance, and share activity without losing the product experience inside a generic fitness feed.',
    solution:
      'A GPS-based ride tracking product with ride statistics, profiles, social comparison, shared rides, and admin monitoring.',
    architecture:
      'Mobile-first product experience backed by location tracking, ride analytics, user profiles, and administrative visibility.',
    stack: ['Mobile App', 'GPS Tracking', 'Ride Analytics', 'User Profiles', 'Admin Monitoring'],
    features: [
      'GPS-based ride tracking',
      'Distance calculation',
      'Average speed',
      'Top speed',
      'User profiles',
      'Ride statistics',
      'Social leaderboard',
      'Friends and shared rides',
      'Admin monitoring',
    ],
    challenges: ['Location accuracy', 'Ride statistics modeling', 'Social product workflows'],
    contribution:
      'Designing and building the product experience, tracking workflows, ride-stat logic, social features, and admin-facing monitoring flows.',
    status: 'Private product in active development',
    code: '',
    demo: '',
  },
  {
    id: 'society-management',
    name: 'Society Management System',
    category: 'Featured Full Stack System',
    image: societyScreenshot,
    problem:
      'Residential societies often rely on fragmented offline processes for fees, visitors, complaints, amenities, security, and maintenance workflows.',
    solution:
      'An offline-first desktop application with role-based workflows for admins, residents, security guards, and maintenance staff.',
    architecture:
      'Electron desktop shell with a React interface and SQLite persistence for local-first operations.',
    stack: ['Electron.js', 'React', 'SQLite', 'TailwindCSS'],
    features: ['Role-based access', 'Local persistence', 'Complaint tracking', 'Visitor and amenity workflows'],
    challenges: ['Designing multi-role UX', 'Keeping offline data reliable', 'Separating operational workflows'],
    contribution:
      'Built the desktop application structure, multi-role workflows, local data handling, and operational UI for society management tasks.',
    code: 'https://github.com/arijit2002/society_management',
    demo: 'https://github.com/arijit2002/society_management',
  },
  {
    id: 'ecommerce-website',
    name: 'E-Commerce Website',
    category: 'Full Stack Web Application',
    image: 'https://raw.githubusercontent.com/arijit2002/redknot_backend/main/Capture1.JPG',
    problem:
      'Online stores need a customer-facing storefront connected to product and order data instead of a static catalog.',
    solution:
      'A MERN e-commerce application with a React storefront and backend/database workflows for product-driven commerce.',
    architecture:
      'React frontend connected to Node.js backend services and MongoDB-backed application data.',
    stack: ['React', 'Node.js', 'MongoDB', 'MERN Stack'],
    features: ['Customer storefront', 'Product data', 'Database-backed workflows', 'Deployed frontend'],
    challenges: ['Full-stack data flow', 'Product browsing UX', 'Frontend/backend integration'],
    contribution:
      'Developed the full-stack structure across the React frontend, Node.js backend, and MongoDB data layer.',
    code: 'https://github.com/arijit2002/redknot_backend',
    demo: 'https://redknot-customer.vercel.app/',
  },
  {
    id: 'banking-management',
    name: 'Banking Management System',
    category: 'Full Stack Web Application',
    image: 'https://raw.githubusercontent.com/arijit2002/modernbank-client-frontend/main/Bank.JPG',
    problem:
      'Banking-style applications need separate user and admin experiences with authentication and persistent data.',
    solution:
      'A MERN banking management application with client and admin panels and Auth0-based authentication.',
    architecture:
      'React client interfaces backed by Node.js, MongoDB, and Auth0 authentication workflows.',
    stack: ['React', 'Node.js', 'MongoDB', 'Auth0'],
    features: ['Client panel', 'Admin panel', 'Authentication', 'MongoDB-backed data'],
    challenges: ['Role-separated interfaces', 'Authentication flow', 'Admin/user workflow design'],
    contribution:
      'Built full-stack application flows across user-facing and admin-facing experiences with authentication and data-backed UI.',
    code: 'https://github.com/arijit2002/modernbank-client-frontend',
    demo: 'https://banking-react-client-side.vercel.app/',
  },
];

export const projectGroups = [
  {
    title: 'Backend Projects',
    description: 'API, authentication, server-side logic, and database-backed systems.',
    projects: [
      {
        name: 'JWT Authentication System',
        stack: ['Node.js', 'MongoDB', 'Mongoose', 'JWT'],
        problem: 'Applications need a secure foundation for registration, login, and protected backend routes.',
        solution: 'A stateless authentication system using JSON Web Tokens and MongoDB-backed user records.',
        features: ['User registration', 'Login workflow', 'JWT authentication', 'MongoDB persistence'],
        contribution: 'Implemented the authentication flow, token handling, and database-backed user model.',
        code: 'https://github.com/arijit2002/mongoose_jwt_auth',
        demo: 'https://github.com/arijit2002/mongoose_jwt_auth',
      },
      {
        name: 'Dockerized Express App',
        stack: ['Node.js', 'Express.js', 'Docker'],
        problem: 'Backend applications need consistent behavior across local and deployment environments.',
        solution: 'A containerized Express application packaged with Docker for repeatable runtime setup.',
        features: ['Express server', 'Docker runtime', 'Portable deployment setup'],
        contribution: 'Built the Express application structure and Dockerized the runtime for consistent deployment.',
        code: 'https://github.com/arijit2002/docker-express',
        demo: 'https://github.com/arijit2002/docker-express',
      },
      {
        name: 'Product Management System',
        stack: ['Java', 'Spring Boot', 'Spring Security', 'PostgreSQL'],
        problem: 'Product data needs controlled administration with user access and persistent storage.',
        solution: 'A Spring Boot product management application with CRUD operations, login, and access control.',
        features: ['Product CRUD', 'User registration', 'Login', 'Spring Security', 'PostgreSQL storage'],
        contribution: 'Implemented the backend application, security layer, database integration, and product workflows.',
        code: 'https://github.com/arijit2002/Product-Management-System-PostgreSQL',
        demo: '',
      },
    ],
  },
  {
    title: 'Cloud Projects',
    description: 'AWS-focused projects covering serverless functions, email services, and cloud databases.',
    projects: [
      {
        name: 'AWS Lambda Source Control',
        stack: ['AWS', 'Lambda', 'Serverless', 'JavaScript'],
        problem: 'Serverless functions are hard to maintain when deployment code is not version controlled.',
        solution: 'A source-control workflow for AWS Lambda functions with versioned deployment practice.',
        features: ['AWS Lambda workflow', 'Version control', 'Serverless deployment practice'],
        contribution: 'Created the Lambda source-control setup and documented a more maintainable serverless workflow.',
        code: 'https://github.com/arijit2002/AWS-Lambda-SourceControl',
        demo: 'https://github.com/arijit2002/AWS-Lambda-SourceControl',
      },
      {
        name: 'AWS SES Email Service',
        stack: ['AWS', 'SES', 'Node.js'],
        problem: 'Applications often need reliable programmatic email delivery for notifications and workflows.',
        solution: 'A Node.js integration with Amazon Simple Email Service for sending emails through AWS.',
        features: ['AWS SES integration', 'Programmatic email sending', 'Node.js service logic'],
        contribution: 'Implemented the SES integration and backend logic for cloud-based email delivery.',
        code: 'https://github.com/arijit2002/AWS-SES',
        demo: 'https://github.com/arijit2002/AWS-SES',
      },
      {
        name: 'Python DynamoDB',
        stack: ['Python', 'AWS', 'DynamoDB'],
        problem: 'Cloud applications need practical NoSQL persistence patterns.',
        solution: 'A Python application demonstrating CRUD operations with AWS DynamoDB.',
        features: ['Create records', 'Read records', 'Update records', 'Delete records', 'DynamoDB integration'],
        contribution: 'Built the Python data-access workflows and AWS DynamoDB integration.',
        code: 'https://github.com/arijit2002/python_dynamoDB',
        demo: 'https://github.com/arijit2002/python_dynamoDB',
      },
    ],
  },
  {
    title: 'Additional Web & Data Projects',
    description: 'Supporting projects that show data visualization, backend practice, and framework exploration.',
    projects: [
      {
        name: 'Crime Lab of India',
        stack: ['Python', 'Flask', 'Pandas', 'Matplotlib'],
        problem: 'Public datasets are difficult to understand without interactive summaries and visualizations.',
        solution: 'A Flask data visualization app using Python data tools to present crime data from India.',
        features: ['Data processing', 'Flask app', 'Charts', 'Public dataset exploration'],
        contribution: 'Built the Python/Flask application and data visualization workflow.',
        code: 'https://github.com/arijit2002/crime_lab',
        demo: 'https://crime-lab.onrender.com/',
      },
      {
        name: 'Weather Search App',
        stack: ['Python', 'Flask', 'JavaScript', 'HTML', 'CSS'],
        problem: 'Users need a simple way to look up current weather by city.',
        solution: 'A Flask web app that accepts a city search and displays current weather information.',
        features: ['City search', 'Weather display', 'Flask backend', 'Simple responsive UI'],
        contribution: 'Built the Flask application flow and frontend search interface.',
        code: 'https://github.com/arijit2002/weather',
        demo: '',
      },
      {
        name: 'Crime Lab of India (Django)',
        stack: ['Python', 'Django', 'SQLite', 'Data Analysis'],
        problem: 'Crime datasets benefit from alternate web implementations that support relational persistence.',
        solution: 'A Django implementation for exploring crime statistics across India.',
        features: ['Django app structure', 'SQLite persistence', 'Crime data exploration'],
        contribution: 'Built a Django-based version of the crime data exploration workflow.',
        code: 'https://github.com/arijit2002/django_crimelab',
        demo: '',
      },
    ],
  },
];

export const skillGroups = [
  { title: 'Backend', icon: 'Server', skills: ['Node.js', 'Express.js', 'Python', 'Java', 'REST APIs', 'Authentication'] },
  { title: 'Cloud', icon: 'Cloud', skills: ['AWS', 'Lambda', 'SES', 'DynamoDB', 'Serverless', 'Cloud Architecture'] },
  { title: 'Frontend', icon: 'Layout', skills: ['React', 'JavaScript', 'HTML', 'CSS', 'Bootstrap', 'TailwindCSS'] },
  { title: 'Databases', icon: 'Database', skills: ['MongoDB', 'MySQL', 'PostgreSQL', 'SQLite', 'NoSQL Modeling'] },
  { title: 'DevOps', icon: 'Terminal', skills: ['Docker', 'Git', 'Ubuntu', 'Deployment Workflows'] },
  { title: 'Enterprise Platforms', icon: 'Briefcase', skills: ['Qualtrics', 'Medallia', 'Customer Experience Platforms', 'Enterprise Delivery'] },
  { title: 'Languages', icon: 'Code', skills: ['JavaScript', 'Python', 'Java', 'C', 'C++', 'SQL'] },
];

export const credentials = [
  { title: 'AWS Cloud Practitioner', provider: 'Amazon Web Services', category: 'Cloud', image: aws },
  { title: 'Qualtrics Technology Consultant', provider: 'Qualtrics', category: 'Enterprise Platform', image: placeholder },
  { title: 'Medallia Product Certified', provider: 'Medallia', category: 'Enterprise Platform', image: placeholder },
  { title: 'Network Security Associate 2', provider: 'Fortinet', category: 'Networking', image: nse2 },
  { title: 'Network Security Associate 1', provider: 'Fortinet', category: 'Networking', image: nse1 },
  { title: 'SQL Certification', provider: 'HackerRank', category: 'Database', image: sql },
  { title: 'Python Certification', provider: 'HackerRank', category: 'Programming', image: python },
];

export const github = {
  username: 'arijit2002',
  contributionGraph: 'https://ghchart.rshah.org/2f81f7/arijit2002',
  statsImage: 'https://github-readme-stats.vercel.app/api?username=arijit2002&show_icons=true&theme=transparent&hide_border=true&title_color=93c5fd&text_color=cbd5e1&icon_color=34d399',
  repos: [
    { name: 'society_management', description: 'Offline-first society management desktop app.', url: 'https://github.com/arijit2002/society_management' },
    { name: 'Microservices_Docker_Deployment', description: 'Node.js and Python microservices with Docker.', url: 'https://github.com/arijit2002/Microservices_Docker_Deployment' },
    { name: 'python_dynamoDB', description: 'Python CRUD workflows with AWS DynamoDB.', url: 'https://github.com/arijit2002/python_dynamoDB' },
  ],
};

export const articles = [
  {
    title: 'Engineering Notes',
    source: 'Medium / Hashnode / Research',
    description: 'A dedicated technical writing section is ready for articles on backend systems, AWS, AI applications, and system design.',
    url: 'https://medium.com/',
  },
];
